import { Endpoints } from "src/base/Endpoints";
import { HttpMethod } from "src/helpers";
import { IApiService } from "src/services/api/ApiService";
import {
  IComnetMaterial,
  IMedicalRecordComnetMaterial,
} from "../../domain/model/comnetMaterial";

export interface IComnetRemoteDataSource {
  getMaterials(): Promise<IComnetMaterial[]>;
  getMedicalRecordMaterials(medicalRecordId: string): Promise<IMedicalRecordComnetMaterial[]>;
  addMedicalRecordMaterial(
    medicalRecordId: string,
    comnetClinicMaterialId: number,
    isShared: boolean,
    comment: string
  ): Promise<{ id: number }>;
  updateMedicalRecordMaterial(id: number, isShared: boolean, comment: string): Promise<void>;
  removeMedicalRecordMaterial(id: number): Promise<void>;
}

export class ComnetRemoteDataSource implements IComnetRemoteDataSource {
  apiService: IApiService;
  constructor(apiService: IApiService) {
    this.apiService = apiService;
  }

  async getMaterials(): Promise<IComnetMaterial[]> {
    const response = await this.apiService.request({
      method: HttpMethod.GET,
      endpoint: Endpoints.comnetMaterials,
      shouldAuthorize: true,
    });
    if (!response.data || !response.data.data) return [];
    return response.data.data;
  }

  async getMedicalRecordMaterials(medicalRecordId: string): Promise<IMedicalRecordComnetMaterial[]> {
    const response = await this.apiService.request({
      method: HttpMethod.GET,
      endpoint: Endpoints.comnetMedicalRecordMaterials(medicalRecordId),
      shouldAuthorize: true,
    });
    if (!response.data || !response.data.data) return [];
    return response.data.data;
  }

  async addMedicalRecordMaterial(
    medicalRecordId: string,
    comnetClinicMaterialId: number,
    isShared: boolean,
    comment: string
  ): Promise<{ id: number }> {
    const response = await this.apiService.request({
      method: HttpMethod.POST,
      endpoint: Endpoints.comnetMedicalRecordMaterials(medicalRecordId),
      body: {
        data: {
          comnet_clinic_material_id: comnetClinicMaterialId,
          is_shared: isShared,
          comment,
        },
      },
      shouldAuthorize: true,
    });
    return response.data.data;
  }

  async updateMedicalRecordMaterial(id: number, isShared: boolean, comment: string): Promise<void> {
    await this.apiService.request({
      method: HttpMethod.PUT,
      endpoint: Endpoints.comnetMedicalRecordMaterial(id),
      body: {
        data: {
          is_shared: isShared,
          comment,
        },
      },
      shouldAuthorize: true,
    });
  }

  async removeMedicalRecordMaterial(id: number): Promise<void> {
    await this.apiService.request({
      method: HttpMethod.DELETE,
      endpoint: Endpoints.comnetMedicalRecordMaterial(id),
      shouldAuthorize: true,
    });
  }
}
